<template>
	<div>
		<action-sidebar
			title="Cambiar Contraseña"
			:value="true"
			@close-modal="closeModal"
		>
			<users-form 
			:user-id="id"
			:codeProject="codeProject"/>
		</action-sidebar>
	</div>
</template>

<script>
import actionSidebar from '@/components/shared/action-sidebar';
import usersForm from '@/components/users/users-form-change-password';

function closeModal() {
	this.goTo('page-user');
}

export default {
	name: 'page-users-change-password',
	components: {
		actionSidebar,
		usersForm,
	},
	methods: {
		closeModal,
	},
	props: {
		id: {
			type: String,
		},
		codeProject: {
			type: String,
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/pages/users/page-users-change-password.vue